export const SOURCE_LABELS = {
  bidfta: 'BidFTA',
  bidsoflo: 'BidSoflo',
  dealvara: 'Dealvara',
  macbid: 'Mac.Bid',
  bidauctiondepot: 'Bid Auction Depot',
};

export const sourceLabel = source => SOURCE_LABELS[source] || source || null;



// WEBPACK FOOTER //
// ./src/utils/source.js